import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '15px',
  },
  modalSubTitle: {
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
    marginBottom: '20px',
  },
  emailHeader: {
    display: 'inline-flex',
    width: '100%',
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '13px',
    color: '#2C2D3E',
  },
  email: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    color: '#2C2D3E',
    marginLeft: '5px',
  },
  closeButton: {
    position: 'relative',
    marginLeft: '339px',
    marginTop: '15px',
    width: '30px',
    height: '30px',
    background: '#FFFFFF',
    border: '1px solid #2C2D3E',
    borderRadius: '3px',
    fontSize: 'small',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  line: {
    width: '570px',
    size: '0px',
    color: '#2c2d3e',
    opacity: 0.3,
    display: 'flex',
    align: 'center',
    margin: '10px 10px 10px -10px',
  },
  footer: {
    fontFamily: 'Roboto',
    color: '#2C2D3E',
    fontWeight: 400,
    fontSize: 12,
    textAlign: 'center',
    paddingBottom: '10px',
  },
  errorMessagesContainer: {
    maxWidth: '300px',
    height: '5px',
    margin: '5px 0px 0px 5px',
  },
  errorMessage: {
    fontFamily: 'Roboto',
    color: '#BC0000',
    fontWeight: 400,
    fontSize: '12px',
  },
}));
